module.exports = __webpack_public_path__ + "img/Union.d6422d4e.svg";